import { render } from "./add-reports.vue?vue&type=template&id=a400c8f4&scoped=true"
import script from "./add-reports.vue?vue&type=script&lang=js"
export * from "./add-reports.vue?vue&type=script&lang=js"

import "./add-reports.vue?vue&type=style&index=0&id=a400c8f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a400c8f4"]])

export default __exports__